import React, { FC } from 'react';
import { getIcon } from '../IconsMap/IconsMap';
import { IFooterProps } from '../../declarations/types';
import { contactsItemsDefault } from '../../utils/constants';

export const Footer: FC<IFooterProps> = ({
  contactsItems = contactsItemsDefault,
}) => {
  return (
    <footer className='commonFooter'>
      <div className='commonFooterContent'>
        {contactsItems.map((item) => (
          <div key={item.id} className={'footerContentItem'}>
            <div className={'footerContentIcon'}>
              {item.icon ? getIcon(item.icon) : getIcon('LocationIcon')}
            </div>
            <div className='footerContentText'>
              {
                (item.href && item.href.length > 0) ? <a href={item.href}>{item.text}</a> : item.text
              }
            </div>
          </div>
        ))}
      </div>
    </footer>
  );
};
